import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { triggerPublicEvent, PublicEvents } from '@project/shared/utils/events/js/events';

const classes = {
	listFirstLevel: 'js-m-filter-two-level-multiselect__list-level1',
	listFirstLevelOpen: 'm-filter-two-level-multiselect__list-level1--open',
	listFirstLevelShadow: 'm-filter-two-level-multiselect__list-level1--shadow',
	itemFirstLevel: 'js-m-filter-two-level-multiselect__item--level1',
	itemFirstLevelOpen: 'm-filter-two-level-multiselect__item--level1-open',
	itemFirstLevelHeaderMobile: 'm-filter-two-level-multiselect__item-link--main-mobile',
	itemFirstLevelHeaderMobileOpen: 'm-filter-two-level-multiselect__item-link--main-mobile-header',
	mainItemLink: 'js-m-filter-two-level-multiselect__item-link--main',
	mainItemChecked: 'm-filter-two-level-multiselect__item-link--main-checked',
	layerSecondLevel: 'js-m-filter-two-level-multiselect__layer-level2',
	layerFirstLevelBacklink: 'js-m-filter-two-level-multiselect__backlink',
	layerSecondLevelBacklink: 'js-m-filter-two-level-multiselect__backlink-level2',
	layerSecondLevelHeader: 'js-m-filter-two-level-multiselect__layer-header-level2',
	layerSecondLevelSubfilterOpen: 'm-filter-two-level-multiselect__layer-level2--with-sublevel',
	itemSecondLevel: 'js-m-filter-two-level-multiselect__item--level2',
	itemSecondLevelOpen: 'm-filter-two-level-multiselect__item--level2-open',
	itemLinkSecondLevel: 'js-m-filter-two-level-multiselect__item-link',
	itemLinkSecondLevelDisabled: 'm-filter-two-level-multiselect__item-link--parent-disabled',
	itemLinkSecondLevelChecked: 'm-filter-two-level-multiselect__item-link--parent-checked',
	listThirdLevel: 'js-m-filter-two-level-multiselect__list-level3',
	listThirdLevelDisabled:'m-filter-two-level-multiselect__item--child-disabled',
	listThirdLevelOpen: 'm-filter-two-level-multiselect__list-level3--open',
	headerThirdLevel: 'js-m-filter-two-level-multiselect__layer-header-level3',
	itemThirdLevel: 'js-m-filter-two-level-multiselect__item--level3',
	confirmButton: 'js-m-filter-two-level-multiselect__confirm-button',
	floatLabel:'state-a-label--is-floated',
	focusLabel:'state-a-label--is-focus',
	closeFilter:'m-filter-two-level-multiselect__item-link--main-mobile-close-icon'
};

@createModule('FilterTwoLevelMultiselect')
/**
 * $filter-two-level-multiselect terrific module implementation
 *
 * @author Christoph Merkelbach <christoph.merkelbach@namics.com>
 */
export class FilterTwoLevelMultiselect extends TerrificSpec {
	$ctx: JQuery;
	$confirmButton: JQuery;
	$layerSecondLevel: JQuery;
	$itemSecondLevel: JQuery;
	$listFirstLevel: JQuery;
	$itemFirstLevel: JQuery;
	$itemFirstLevelHeaderMobile: JQuery;
	$floatLabel: JQuery;

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);

		this.$floatLabel = this.$ctx.prev();
		this.$floatLabel.addClass(classes.floatLabel);

		this.registerProperties();
		this.bindEvents();

		this.setFilterCheckedClass();
		this.setFilterDisabledClass();

		resolve();
	}

	registerProperties(): void {
		this.$confirmButton = $(`.${classes.confirmButton}`, this.$ctx);
		this.$layerSecondLevel = $(`.${classes.layerSecondLevel}`, this.$ctx);
		this.$itemSecondLevel = $(`.${classes.itemSecondLevel}`, this.$ctx);
		this.$listFirstLevel = $(`.${classes.listFirstLevel}`, this.$ctx);
		this.$itemFirstLevel = $(`.${classes.itemFirstLevel}`, this.$ctx);
		this.$itemFirstLevelHeaderMobile = $(`.${classes.itemFirstLevelHeaderMobile}`, this.$ctx);
	}

	bindEvents(): void {
		$(`.${classes.listFirstLevel}, .${classes.layerSecondLevelHeader}`, this.$ctx).on(
			'click',
			this.onToggleOverlayClick.bind(this)
		);
		this.$confirmButton.on('click', this.onConfirmButtonClick.bind(this));
		$(`.${classes.closeFilter}`, this.$ctx).on('click', this.onCloseFilter.bind(this));
		$(`.${classes.layerFirstLevelBacklink}`, this.$ctx).on('click', this.onBackButtonClick.bind(this));
		$(`.${classes.itemLinkSecondLevel}`, this.$ctx).on('click', this.onOpenCategoryClick.bind(this));
		$(`.${classes.layerSecondLevelBacklink}`, this.$ctx).on('click', this.onCloseCategoryClick.bind(this));
		$(`.${classes.headerThirdLevel}`, this.$ctx).on('click', this.onPrimaryfilterClick.bind(this));
		$(`.${classes.itemThirdLevel}`, this.$ctx).on('click', this.onSubfilterClick.bind(this));

		this.$layerSecondLevel.on('click', (event: Event) => {
			event.stopPropagation();
		});
		$('input[type=checkbox]', this.$ctx).on('click', (event: Event) => {
			event.preventDefault();
		});
	}

	/**
	 * Intended for (re)initializing event handlers after modifying the contents of the multiselect externally.
	 */
	public rebindEvents(): void {
		$(`.${classes.listFirstLevel}, .${classes.layerSecondLevelHeader}`, this.$ctx).off('click');
		this.$confirmButton.off('click');
		$(`.${classes.closeFilter}`, this.$ctx).off('click');
		$(`.${classes.layerFirstLevelBacklink}`, this.$ctx).off('click');
		$(`.${classes.itemLinkSecondLevel}`, this.$ctx).off('click');
		$(`.${classes.layerSecondLevelBacklink}`, this.$ctx).off('click');
		$(`.${classes.headerThirdLevel}`, this.$ctx).off('click');
		$(`.${classes.itemThirdLevel}`, this.$ctx).off('click');

		this.$layerSecondLevel.off('click');
		$('input[type=checkbox]', this.$ctx).off('click');

		this.registerProperties();
		this.bindEvents();
	}

	onToggleOverlayClick(event: Event) {
		this.toggleFilter();
		event.stopPropagation();
	}

	onConfirmButtonClick(event: Event) {
		this.closeFilter();
		event.stopPropagation();
		event.preventDefault();
	}

	onBackButtonClick(event: Event) {
		this.closeFilter();
		event.stopPropagation();
		event.preventDefault();
	}

	onCloseFilter(event: Event) {
		this.closeFilter();
		this.$ctx.trigger('FilterTwoLevelMultiCloseButton', [event]);
		event.stopPropagation();
		event.preventDefault();
	}

	onCloseCategoryClick(event: Event) {
		this.closeFilterValueClick(event);
		event.stopPropagation();
		event.preventDefault();
	}

	onOpenCategoryClick(event: Event) {
		var $secondLevel = $(event.currentTarget);

		if($secondLevel.hasClass(classes.itemLinkSecondLevelDisabled)) return;

		this.openFilterValueClick(event);
		event.stopPropagation();
		event.preventDefault();
	}

	onPrimaryfilterClick(event: Event) {
		this.setFilter(
			$(event.currentTarget as HTMLElement)
				.parent()
				.find('input[type=checkbox]:not(:disabled)')
		);
		this.$ctx.trigger('FilterTwoLevelMultiCheckboxChanged',[event]);
	}

	onSubfilterClick(event: Event) {
		const $checkbox = $(event.currentTarget as HTMLElement).find('input[type=checkbox]');
		if($checkbox.prop("disabled")) return false;
		this.setFilter($checkbox);
			this.adjustFirstLevelFilterAccordingToSubFilters($checkbox);
			this.$ctx.trigger('FilterTwoLevelMultiCheckboxChanged',[event]);
			this.setFilterCheckedClass();
		}
		 
	adjustFirstLevelFilterAccordingToSubFilters($checkbox: JQuery) {
		const $allCheckboxesOnSameLevel = $checkbox.closest(`.${classes.listThirdLevel}`).find('input[type=checkbox]:not(:disabled)');
		const $firstLevelCheckbox = $checkbox
			.closest(`.${classes.itemSecondLevel}`)
			.find(`.${classes.headerThirdLevel} input[type=checkbox]`);
		$firstLevelCheckbox.prop('checked', this.areAllSubFiltersChecked($allCheckboxesOnSameLevel));
	}

	setFilter($checkbox: JQuery) { 
		$checkbox.prop('checked', !$checkbox.prop('checked'));
		this.$confirmButton.show();

		this.setFilterCheckedClass();
	}

	isAnyFilterChecked($checkboxes: JQuery = $('input[type=checkbox]:not(:disabled)', this.$ctx)) {
		return $checkboxes.toArray().some(this.isElementChecked);
	}

	areAllSubFiltersChecked($checkboxes: JQuery = $('input[type=checkbox]:not(:disabled)', this.$ctx)) {
		return $checkboxes.toArray().every(this.isElementChecked);
	}

	isElementChecked(element: HTMLInputElement) {
		return element.checked;
	}

	setFilterCheckedClass() {
		$(`.${classes.mainItemLink}`, this.$ctx).toggleClass(classes.mainItemChecked, this.isAnyFilterChecked());

		this.$ctx.find(`.${classes.itemSecondLevel}`).each((i,e) => {
			const $firstLevelItem = $(e);
			const $checkboxes = $firstLevelItem.find(`.${classes.itemThirdLevel}`).find('input[type=checkbox]');

			$firstLevelItem
				.find(`.${classes.itemLinkSecondLevel}`)
				.toggleClass(classes.itemLinkSecondLevelChecked, this.isAnyFilterChecked($checkboxes))
		});
	}

	toggleFilter(toggleState?: any) {
		this.closeAllSubFilterValues();
		this.$confirmButton.hide();
		this.$listFirstLevel
			.toggleClass(classes.listFirstLevelOpen, toggleState)
			.toggleClass(classes.listFirstLevelShadow, toggleState);
		this.$itemFirstLevel.toggleClass(classes.itemFirstLevelOpen, toggleState);
		this.$floatLabel.toggleClass(classes.focusLabel, toggleState);
		this.$itemFirstLevelHeaderMobile.toggleClass(classes.itemFirstLevelHeaderMobileOpen, toggleState);
	}

	openFilter() {
		this.toggleFilter(true);
	}

	closeFilter() {
		this.toggleFilter(false);
	}

	openFilterValueClick(event: Event) {
		const $currentTargetElement = $(event.currentTarget);

		if($currentTargetElement.parent().hasClass(classes.itemLinkSecondLevelDisabled)) return false;

		$currentTargetElement.closest(`.${classes.layerSecondLevel}`).addClass(classes.layerSecondLevelSubfilterOpen);
		this.$itemSecondLevel.hide();
		$currentTargetElement
			.closest(`.${classes.itemSecondLevel}`)
			.show()
			.addClass(classes.itemSecondLevelOpen)
			.find(`.${classes.listThirdLevel}`)
			.addClass(classes.listThirdLevelOpen);
	}

	closeAllSubFilterValues() {
		this.$layerSecondLevel.removeClass(classes.layerSecondLevelSubfilterOpen);
		this.$itemSecondLevel
			.show()
			.removeClass(classes.itemSecondLevelOpen)
			.find(`.${classes.listThirdLevel}`)
			.removeClass(classes.listThirdLevelOpen);
	}

	closeFilterValueClick(event: Event) {
		this.$layerSecondLevel.removeClass(classes.layerSecondLevelSubfilterOpen);
		this.$itemSecondLevel.show();
		$(event.currentTarget)
			.closest(`.${classes.itemSecondLevel}`)
			.removeClass(classes.itemSecondLevelOpen)
			.find(`.${classes.listThirdLevel}`)
			.removeClass(classes.listThirdLevelOpen);
	}

	setFilterDisabledClass(){
		this.$ctx.find(`.${classes.itemThirdLevel}`).find('input[type=checkbox]:disabled').closest(`.${classes.itemThirdLevel}`).addClass(classes.listThirdLevelDisabled);

		this.$ctx.find(`.${classes.itemSecondLevel}`).each((i,e) => {
			const $firstLevelItem = $(e);
			const $checkboxes = $firstLevelItem.find(`.${classes.itemThirdLevel}`).find('input[type=checkbox]');

			$firstLevelItem
				.find(`.${classes.itemLinkSecondLevel}`)
				.toggleClass(classes.itemLinkSecondLevelDisabled, this.areAllFilterDisabled($checkboxes));

			$firstLevelItem
				.find(`.${classes.headerThirdLevel}`).find('input[type=checkbox]')
				.prop("disabled", this.areAllFilterDisabled($checkboxes));
		});
	}

	areAllFilterDisabled($checkboxes: JQuery){
		return $checkboxes.toArray().every(this.isElementDisabled);
	}

	isElementDisabled(element: HTMLElement): any {
		return $(element).prop("disabled");
	}

	stop() {}
}
